module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-step-2__col order-step-2__col-2"
  }, [_c('div', {
    staticClass: "order-step-2__col-2-header"
  }, [_c('h3', {
    staticClass: "order-step-2__col-2-heading private"
  }, [_vm._v("Empfohlene Menge / Woche: " + _vm._s(_vm.totalWeight) + " kg")])]), _vm._v(" "), _c('div', {
    staticClass: "order-result-summary__baskets__list private"
  }, [_vm._l((_vm.sortedBasketsPeopleMonday), function(basket, index) {
    return _c('div', {
      key: ("monday-basket-" + index),
      staticClass: "order-result-summary__weight-container"
    }, [_c('span', {
      staticClass: "order-result-summary__weight-text"
    }, [_vm._v("\n                " + _vm._s(basket.kg) + " kg\n            ")])])
  }), _vm._v(" "), _vm._l((_vm.sortedBasketsPeopleWednesday), function(basket, index) {
    return _c('div', {
      key: ("wednesday-basket-" + index),
      staticClass: "order-result-summary__weight-container"
    }, [_c('span', {
      staticClass: "order-result-summary__weight-text"
    }, [_vm._v("\n                " + _vm._s(basket.kg) + " kg\n            ")])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59d85522","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/AppetitePrivate.vue
// module id = 740
// module chunks = 0